import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CalendarDays } from 'lucide-react';

interface DatePickerProps {
  selected: Date | null;
  onChange: (date: Date | null) => void;
  placeholderText?: string;
  label: string;
  minDate?: Date;
  className?: string;
}

export const DatePicker: React.FC<DatePickerProps> = ({ selected, onChange, placeholderText, label, minDate, className }) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-semibold text-zinc-700 flex items-center gap-2">
        <CalendarDays className="w-4 h-4 text-teal-600" />
        {label}
      </label>
      <div className="relative">
        <ReactDatePicker
          selected={selected}
          onChange={onChange}
          dateFormat="yyyy-MM-dd"
          placeholderText={placeholderText}
          minDate={minDate}
          className={`w-full bg-gradient-to-br from-teal-50 to-cyan-50 border-2 border-teal-200 hover:border-teal-300 rounded-xl px-4 py-3.5 font-medium text-zinc-700 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-all ${className || ''}`}
          calendarClassName="custom-datepicker"
          wrapperClassName="w-full"
        />
      </div>
    </div>
  );
};
